module.exports = __webpack_public_path__ + "static/media/magnifying-glass-right.4d531da7.svg";